import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'App';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import History from 'helpers/History';
import './index.css';
import { ConfigProvider } from 'antd';
import idID from 'antd/es/locale/id_ID';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <ConfigProvider locale={idID}>
      <HistoryRouter history={History}>
         <App />
      </HistoryRouter>{' '}
   </ConfigProvider>,
);
